module.exports = __webpack_public_path__ + "static/media/02_quote_desktop.24637d1d.jpg";